module.exports = __webpack_public_path__ + "static/media/leading-wellbeing-large@3x.ad1b76e9.png";